import { useRef } from 'react';
import Image from 'next/image';
import classnames from 'classnames';

import CoverItems from '@/components/CoverItems';

export default function Cover({
  explode = false,
  showShadow = false,
  items,
  ...props
}) {
  const ref = useRef();

  if (!props || !props.image) return null;

  return (
    <div className="relative" ref={ref}>
      <CoverItems items={items} container={ref} />
      <div
        className={classnames('mx-auto rounded', {
          'lg:-mr-84': explode,
          'border shadow-lg': showShadow,
        })}
      >
        <Image
          className="rounded"
          layout="responsive"
          src={props.image.url}
          width={props.image.width}
          height={props.image.height}
          quality={100}
          alt={props.image?.alt}
          objectFit="cover"
          priority
        />
      </div>
    </div>
  );
}
